import { render, staticRenderFns } from "./qq.vue?vue&type=template&id=36cea71a&scoped=true&"
import script from "./qq.vue?vue&type=script&lang=js&"
export * from "./qq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cea71a",
  null
  
)

export default component.exports